/* eslint sort-keys: ["error", "asc", {caseSensitive: false}] */
import { buildScopedTranslationFunction } from '../../lib';

const translate = buildScopedTranslationFunction({
  de: {
    email: 'kontakt@crewmeister.com',
    explainer: 'Ihr Crew wurde gesperrt, bitte kontaktieren Sie uns:',
    header: 'Crew gesperrt',
    phone: '+49 89 215 368 470',
  },
  en: {
    email: 'kontakt@crewmeister.com',
    explainer: 'Your crew is locked, please contact us:',
    header: 'Crew locked',
    phone: '+49 89 215 368 470',
  },
});

export default translate;
